import React from "react";
import {Outlet} from "react-router-dom";
import {Sidebar} from "../common/Sidebar";
import {Header} from "../common/Header";
import RouteProtector from "../../components/common/authorityGuard/RouterProtector";

export const PrivateLayout = () => {
    return <>
        <RouteProtector/>

        <div className="main-sidebar">
            <Sidebar/>
            <div className="main-container">
                <Header/>
                <div className="body-box">
                    <div className="body-container">
                        <Outlet/>
                    </div>
                </div>
            </div>
        </div>
    </>
};
